import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { PasswordInput } from '@synoptic/ui-kit/input/password-input.tsx';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { confirmSignIn } from 'aws-amplify/auth';
import { FC, useRef, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { passwordPattern } from '@/form-utils/password-pattern';
import {
  cardBody,
  formFieldsContainer,
  formHeading,
  submitAuthFormButton,
} from '../_auth/page.css';

type FormInputs = {
  newPassword: string;
};

export const SetNewPasswordForm: FC<{ onNewPasswordSet: () => void }> = ({
  onNewPasswordSet,
}) => {
  const { handleSubmit, formState, register } = useForm<FormInputs>();
  const formRef = useRef<HTMLFormElement>(null);
  const toast = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit: SubmitHandler<FormInputs> = async (data) => {
    setIsSubmitting(true);

    try {
      await confirmSignIn({
        challengeResponse: data.newPassword,
      });

      onNewPasswordSet();
    } catch (e) {
      setIsSubmitting(false);
      toast.error({ title: String(e) });
    }
  };

  return (
    <form ref={formRef} onSubmit={handleSubmit(submit)}>
      <h1 className={formHeading}>Set a new password</h1>
      <p className={cardBody}>
        Your account was created by an administrator with a temporary password.
        Please set your own password to continue.
      </p>
      <div className={formFieldsContainer}>
        <PasswordInput
          {...register('newPassword', {
            required: true,
            pattern: passwordPattern,
          })}
          placeholder={'Enter new password'}
          errorMessage={formState.errors.newPassword?.message}
          label={'New password'}
          autoComplete="new-password"
          autoFocus
        />
        <Button
          className={submitAuthFormButton}
          size={'large'}
          type="submit"
          loading={isSubmitting}
        >
          Submit password
        </Button>
      </div>
    </form>
  );
};
